import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import merge from 'lodash/merge';
import pick from 'lodash/pick';
import Api from 'lib/Api';

import Checkout from 'orders/Checkout';
import Address from 'orders/Address';
import Payment from 'orders/Payment';
import Confirmation from 'orders/Confirmation';
import Summary from 'orders/Summary';
import Empty from 'orders/Empty';
import Submitting from 'orders/Submitting';

import { StripeProvider } from 'react-stripe-elements';

class Cart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step:             1,
      products:         _cartProducts.slice(0),
      shippingCountry:  'FR',
      amounts:          merge({}, _amounts),
      addresses:        {
        shipping: { country: 'FR' },
        billing:  { country: 'FR', sameShipping: true },
      },
      cardholder_name: null,
      stripeToken: null,
      stripe: null,
      order: null,
      isSubmitting: false,
      submittingMessage: null,
    }
  }

  componentDidMount() {
    this.toggleScroll();
  }

  componentDidUpdate() {
    this.toggleScroll();
  }

  toggleScroll() {
    if (this.state.isSubmitting) {
      document.body.classList.add('-noscroll');
    }
    else {
      document.body.classList.remove('-noscroll');
    }
  }

  goNext = () => {
    this.setState(merge({}, this.state, {
      step: this.state.step + 1
    }));
  }

  goStart = () => {
    this.goTo(1);
  }

  goTo = step => {
    this.setState(merge({}, this.state, {
      step: step
    }));
  }

  enterTunnel = () => {
    this.goNext();
    document.querySelector('.shopSidebar').classList.add('-isOff');
  }

  setStripe = stripe => {
    this.setState(merge({}, this.state, { stripe }));
  }

  createOrder = formValues => {
    if (!this.state.stripe) return;

    $('html, body').animate({ scrollTop: 0 });
    this.setState(merge({}, this.state, { isSubmitting: true, submittingMessage: App.t('cart.creating_order') })); // messages are inverted but makes more sense to the user

    this.requestStripeToken(formValues, () => {
      this.setState(merge({}, this.state, { submittingMessage: App.t('cart.paying_order') }));

      Api.post(_routes.createOrder, { ...this.state.addresses, card_token: this.state.stripeToken }).then(response => {
        this.setState(merge({}, this.state, { order: response.body, isSubmitting: false, submittingMessage: null }), this.goNext);
      }, error => {
        this.setState(merge({}, this.state, { isSubmitting: false, submittingMessage: null }));
      });
    });
  }

  requestStripeToken(formValues, then) {
    const customer = this.state.addresses.billing;

    this.state.stripe.createToken({
      name: formValues.cardholder_name,
      address_line1: customer.street,
      address_line2: '',
      address_city: customer.city,
      address_zip: customer.post_code,
      address_country: customer.country
    }).then(result => {
      if ('token' in result) this.setState(merge({}, this.state, { stripeToken: result.token.id }), then);
      else this.setState(merge({}, this.state, { isSubmitting: false, submittingMessage: null }));
    });
  }

  handleChangeCountry = e => {
    this.changeCountry(e.target.value);
  }

  changeCountry = shippingCountry => {
    this.setState(merge({}, this.state, {
      shippingCountry
    }), () => {
      this.refreshAmounts();
    });
  }

  setAddresses = values => {
    this.setState(merge({}, this.state, { addresses: values }));
    const shippingCountry = values.billing.sameShipping ? values.billing.country : values.shipping.country;
    if (this.state.shippingCountry != shippingCountry) this.changeCountry(shippingCountry);
  }

  refreshAmounts() {
    Api.post(_routes.getAmounts, { shippingCountry: this.state.shippingCountry }).then(response => {
      const newState = merge({}, this.state);
      newState.amounts = merge({}, response.body);
      this.setState(newState);
    });
  }

  setQuantity = (product, newQuantity) => {
    if (newQuantity == 0) {
      return confirm(App.t('cart.remove_from_cart')) ? this.deleteFromCart(product) : null;
    }

    const newState = merge({}, this.state);

    newState.products.forEach(p => {
      if (p.productId == product.productId && p.skuId == product.skuId) {
        p.quantity = newQuantity;
        p.totalPrice = p.price * parseInt(newQuantity);
      }
    });

    this.setState(newState);

    Api.put(_routes.setQuantity, { product_id: product.productId, sku_id: product.skuId, quantity: newQuantity }).then(response => {
      newState.amounts = response.body.amounts;
      this.setState(newState);
    });
  }

  deleteFromCart = product => {
    const newState = merge({}, this.state);

    Api.put(_routes.removeFromCart, { product_id: product.productId, sku_id: product.skuId }).then(response => {
      newState.products = response.body.products;
      newState.amounts = response.body.amounts;
      this.setState(newState);
      ShopBuy.updateCart(response.body);
    });
  }

  stepOptions(step) {
    const classNames = ['cart-step'];

    if (this.state.step == step) classNames.push('-isOn');
    if (step < this.state.step) classNames.push('-isClickable');

    return {
      className: classNames.join(' '),
      onClick: step < this.state.step ? () => this.goTo(step) : undefined,
    };
  }

  tunnelSteps() {
    if (this.state.step < 2) return null;

    return (
      <ul className="cart-steps">
        <li {...this.stepOptions(1)}>
          <span className="cart-stepWrap">
            <span className="cart-stepNum">1</span>
            <span className="cart-stepLabel">{App.t('cart.step_1')}</span>
          </span>
        </li>
        <li {...this.stepOptions(2)}>
          <span className="cart-stepWrap">
            <span className="cart-stepNum">2</span>
            <span className="cart-stepLabel">{App.t('cart.step_2')}</span>
          </span>
        </li>
        <li {...this.stepOptions(3)}>
          <span className="cart-stepWrap">
            <span className="cart-stepNum">3</span>
            <span className="cart-stepLabel">{App.t('cart.step_3')}</span>
          </span>
        </li>
        <li {...this.stepOptions(4)}>
          <span className="cart-stepWrap">
            <span className="cart-stepNum">4</span>
            <span className="cart-stepLabel">{App.t('cart.step_4')}</span>
          </span>
        </li>
      </ul>
    )
  }

  summary() {
    if (this.state.step < 2 || this.state.step >= 4) return null;

    return (
      <Summary
        editCart={this.goStart}
        products={this.state.products}
        amounts={this.state.amounts}
      />
    )
  }

  currentStep() {
    if (this.state.products.length == 0) {
      return (
        <Empty />
      )
    }

    switch(this.state.step) {
      case 1: return (
        <Checkout
          {...pick(this.state, ['shippingCountry', 'amounts'])}
          changeCountry={this.handleChangeCountry}
          setQuantity={this.setQuantity}
          deleteFromCart={this.deleteFromCart}
          products={this.state.products}
          goNext={this.enterTunnel}
        />
      )
      case 2: return (
        <Address
          setAddresses={this.setAddresses}
          values={this.state.addresses}
          goNext={this.goNext}
          changeCountry={this.changeCountry}
          amounts={this.state.amounts}
        />
      )
      case 3: return (
        <StripeProvider apiKey={_stripeKey}>
          <Payment
            createOrder={this.createOrder}
            setStripe={this.setStripe}
            tokenReceived={!!(this.state.stripe && this.state.stripeToken)}
          />
        </StripeProvider>
      )
      case 4: return (
        <Confirmation
          products={this.state.products}
          amounts={this.state.amounts}
          addresses={this.state.addresses}
          order={this.state.order}
          email={this.state.addresses.billing.email}
        />
      )
    }
  }

  render() {
    return (
      <div>
        {this.tunnelSteps()}
        {this.summary()}
        {this.currentStep()}
        {this.state.isSubmitting && ReactDOM.createPortal(<Submitting message={this.state.submittingMessage} />, document.body)}
      </div>
    );
  }

}

export default Cart;
